export default "__VITE_ASSET__i5lGXU8e__"